import { graphql } from 'relay-runtime';

export const UNIFIED_ACCOUNT_QUERY = graphql`
  query UnifiedAccountQuery($aaid: String!) {
    unified {
      account(aaid: $aaid) {
        ... on UnifiedAccount {
          id
          aaid
          emailId
          internalId
          isLinked
          isManaged
          isPrimary
          isForumsModerator
          picture
          nickname
          linkedAccounts {
            ... on UnifiedLinkedAccountConnection {
              edges {
                node {
                  id
                  aaid
                  emailId
                  internalId
                  isLinked
                  isManaged
                  isPrimary
                  nickname
                  picture
                }
                cursor
              }
              totalCount
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
            }
            ... on UnifiedQueryError {
              identifier
              message
              extensions {
                errorType
                statusCode
              }
            }
          }
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
